// features/orders/hooks/useOrders.js
import { useState, useEffect, useCallback } from 'react'
import { apiFetch } from '../../../api'

/**
 * Hook pour charger et gérer les commandes avec auto-pagination
 */
export function useOrders(filters = {}) {
  const [orders, setOrders] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const buildQueryString = useCallback((params) => {
    const qs = new URLSearchParams()
    Object.entries(params || {}).forEach(([k, v]) => {
      if (v === undefined || v === null) return
      const s = String(v).trim()
      if (!s) return
      qs.set(k, s)
    })
    return qs.toString()
  }, [])

  const fetchOrders = useCallback(async () => {
    setLoading(true)
    setError(null)

    try {
      const PAGE_SIZE = 200
      let offset = 0
      let all = []
      let hasMore = true

      while (hasMore) {
        const qs = buildQueryString({ ...filters, limit: PAGE_SIZE, offset })
        const data = await apiFetch(`/api/orders?${qs}`)

        const list = Array.isArray(data)
          ? data
          : Array.isArray(data?.rows)
          ? data.rows
          : Array.isArray(data?.items)
          ? data.items
          : []

        all = all.concat(list)
        hasMore = data?.has_more === true && list.length === PAGE_SIZE
        offset += PAGE_SIZE
      }

      setOrders(all)
    } catch (err) {
      setError(err.message || 'Erreur chargement commandes')
      console.error('useOrders error:', err)
    } finally {
      setLoading(false)
    }
  }, [filters, buildQueryString])

  useEffect(() => {
    fetchOrders()
  }, [fetchOrders])

  return {
    orders,
    loading,
    error,
    refetch: fetchOrders,
  }
}
